import { ButtonSize, ButtonType, JokerButton } from "material-ui-jokerpro";
import React from "react";
import Paragraph, { ParagraphSize } from "../../../components/Paragraph";
import TitleText, { TitleTextSize } from "../../../components/TitleText";
import AssetsPack from "../../../util/AssetsPack.js";
import styles from "./JokerProDownload.module.css";

interface JokerProDownloadProps {
  title: string;
  description: string;
  downloadLink?: string;
  learnMoreLink?: string;
  secondButtonName?: string;
}

/** Main page download */
const JokerProDownload: React.FC<JokerProDownloadProps> = ({
  title,
  description,
  downloadLink,
  learnMoreLink,
  secondButtonName,
}) => {
  return (
    <div className={styles["overlay-container"]}>
      <TitleText size={TitleTextSize.heading1}>{title}</TitleText>
      <Paragraph
        size={ParagraphSize.paragraph1}
        classNameStyle={styles["sub-title-container"]}
      >
        {description}
      </Paragraph>

      <div className={styles["overlay-buttons"]}>
        {downloadLink && (
          <JokerButton
            text="Download APK"
            type={ButtonType.CTA}
            size={ButtonSize.Medium}
            href={downloadLink}
            icon={AssetsPack.icons.ICON_GO.default}
          />
        )}
        {learnMoreLink && (
          <JokerButton
            text={secondButtonName ? secondButtonName : "Learn more"}
            type={ButtonType.Text}
            size={ButtonSize.Medium}
            href={learnMoreLink}
            icon={AssetsPack.icons.ICON_GO.default}
          />
        )}
      </div>
    </div>
  );
};

export default JokerProDownload;
